import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './UsedVans.css';
import heroImage from '../assets/images/used-vans-hero.jpg';
import panelVansImage from '../assets/images/red-combi-van.jpg';
import doubleCabImage from '../assets/images/double-cab-ford-tipper.png';
import chassisCabImage from '../assets/images/chassis-cab.jpg';
import crewVanImage from '../assets/images/combi-van-ford-transit-custom.png';

function UsedVans() {
  const [showAllBrands, setShowAllBrands] = useState(false); // State to manage brand visibility

  const toggleShowBrands = () => {
    setShowAllBrands(!showAllBrands); // Toggle visibility
  };
  const [faq, setFaq] = useState([
    { question: "What is the best time to buy a used van?", answer: "The best times to buy a used van are often at the end of the year or during the transition between new model years when dealerships may offer deals on older stock. Additionally, buying at the end of a financial quarter (March, June, September, December) can sometimes yield better deals, as sellers are eager to meet sales targets. Consider shopping during holiday sales or off-peak months, such as January and February, when demand is lower, which may also lead to better pricing.", isOpen: false },
    { question: "Can I lease a used van?", answer: "Yes, leasing a used van is an option, though it's less common than leasing new vehicles. Some dealerships and leasing companies offer certified pre-owned (CPO) vans for lease, often with slightly lower monthly payments compared to new van leases. Used van leases can be ideal if you’re looking for lower payments without the long-term commitment of ownership. Be sure to verify the van’s condition and the specific terms, as mileage and wear-and-tear guidelines still apply.", isOpen: false },
    { question: "What should I look for in a used van?", answer: "When evaluating a used van, check the exterior and interior for signs of wear, rust, and damage. Inspect the engine, brakes, tires, and suspension to ensure they’re in good working order. Review the van’s service history, mileage, and prior ownership to understand its maintenance record. Additionally, check that all electronics and features, such as air conditioning, lights, and locks, are functioning properly. If possible, have a mechanic perform an inspection before purchase.", isOpen: false },
    { question: "How do I get a van history report?", answer: "You can obtain a van history report through services like HPI Check, Carfax, or AutoCheck by entering the van’s Vehicle Identification Number (VIN). A history report reveals important details, including any previous accidents, recorded mileage, title issues, service history, and whether the vehicle was reported stolen or used commercially. Some dealers may provide a report for free, so always ask before purchasing.", isOpen: false },
    // Add more FAQs here as needed
  ]);

  const toggleFaq = (index) => {
    setFaq(faq.map((item, i) => (i === index ? { ...item, isOpen: !item.isOpen } : item)));
  };

  const [make, setMake] = useState('');
  const [model, setModel] = useState('');
  const [makes, setMakes] = useState([]);
  const [models, setModels] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch all van makes
    axios.get('/api/vehicles/distinct/van')
      .then(res => setMakes(res.data.make.sort()))
      .catch(err => console.error('Error fetching makes:', err));
  }, []);

  useEffect(() => {
    // Fetch models when make changes
    if (!make) {
      setModels([]);
      setModel('');
      return;
    }
    axios.get(`/api/vehicles/distinct/van?make=${encodeURIComponent(make)}`)
      .then(res => setModels(res.data.model.sort()))
      .catch(err => console.error('Error fetching models:', err));
  }, [make]);

  const handleMakeChange = e => setMake(e.target.value);
  const handleModelChange = e => setModel(e.target.value);
  const handleSearch = e => {
    e.preventDefault();
    const parts = [];
    if (make) parts.push(`make=${encodeURIComponent(make)}`);
    if (model) parts.push(`model=${encodeURIComponent(model)}`);
    navigate(`/van-search?${parts.join('&')}`);
  };

  return (
    <div className="used-vans-page">
      {/* Hero Section */}
      <section
        className="vans-hero"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="vans-hero__content">
          <h2>Used Vans</h2>
          <p>The UK's largest choice of pre-loved vans</p>
          <form className="vans-search-form" onSubmit={handleSearch}>
            <select name="make" value={make} onChange={handleMakeChange}>
              <option value="">Make</option>
              {makes.map(m => <option key={m} value={m}>{m}</option>)}
            </select>
            <select name="model" value={model} onChange={handleModelChange} disabled={!make}>
              <option value="">Model</option>
              {models.map(mo => <option key={mo} value={mo}>{mo}</option>)}
            </select>
            <button type="submit" className="cta-button">Search Vans</button>
          </form>
        </div>
      </section>

      {/* Find a Van Section */}
      <section className="find-a-van">
        <h2>Find a van that suits you</h2>
        <div className="model-grid">
          <Link to="/van-search?bodyType=Panel%20van" className="model-card">
            <img src={panelVansImage} alt="Panel Vans" className="model-image" />
            <div className="model-title">Panel Vans</div>
          </Link>
          <Link to="/van-search?bodyType=Double%20cab" className="model-card">
            <img src={doubleCabImage} alt="Double Cabs" className="model-image" />
            <div className="model-title">Double Cabs</div>
          </Link>
          <Link to="/van-search?bodyType=Chassis%20van" className="model-card">
            <img src={chassisCabImage} alt="Chassis Vans" className="model-image" />
            <div className="model-title">Chassis Vans</div>
          </Link>
          <Link to="/van-search?bodyType=Crew%20van" className="model-card">
            <img src={crewVanImage} alt="Crew Vans" className="model-image" />
            <div className="model-title">Crew Vans</div>
          </Link>
        </div>
      </section>


      {/* Browse by Brand Section */}
      <section className="browse-brands">
        <h2>Browse vans by brand</h2>
        <div className="brand-grid">
        <Link to="/van-search?make=Ford" className="brand-logo">
            <img src={require('../assets/logos/ford-logo.jpg')} alt="Ford Logo" />
            <span>Ford</span>
          </Link>
          <Link to="/van-search?make=Volkswagen" className="brand-logo">
            <img src={require('../assets/logos/volkswagen-logo.jpg')} alt="Volkswagen Logo" />
            <span>Volkswagen</span>
          </Link>
          <Link to="/van-search?make=Mercedes-Benz" className="brand-logo">
            <img src={require('../assets/logos/mercedes-logo.jpg')} alt="Mercedes-Benz Logo" />
            <span>Mercedes-Benz</span>
          </Link>
          <Link to="/van-search?make=Renault" className="brand-logo">
            <img src={require('../assets/logos/renault-logo.jpg')} alt="Renault Logo" />
            <span>Renault</span>
          </Link>
          {showAllBrands && (
            <>
              {/* Additional brands */}
              <Link to="/van-search?make=Citroen" className="brand-logo">
                <img src={require('../assets/logos/citroen-logo.jpg')} alt="Citroen Logo" />
                <span>Citroen</span>
              </Link>
              <Link to="/van-search?make=Fiat" className="brand-logo">
                <img src={require('../assets/logos/fiat-logo.jpg')} alt="Fiat Logo" />
                <span>Fiat</span>
              </Link>
              <Link to="/van-search?make=Iveco" className="brand-logo">
                <img src={require('../assets/logos/iveco-logo.jpg')} alt="Iveco Logo" />
                <span>Iveco</span>
              </Link>
              <Link to="/van-search?make=Man" className="brand-logo">
                <img src={require('../assets/logos/man-logo.jpg')} alt="Man Logo" />
                <span>Man</span>
              </Link>
              <Link to="/van-search?make=Maxus" className="brand-logo">
                <img src={require('../assets/logos/maxus-logo.jpg')} alt="Maxus Logo" />
                <span>Maxus</span>
              </Link>
              <Link to="/van-search?make=Nissan" className="brand-logo">
                <img src={require('../assets/logos/nissan-logo.jpg')} alt="Nissan Logo" />
                <span>Nissan</span>
              </Link>
              <Link to="/van-search?make=Peugeot" className="brand-logo">
                <img src={require('../assets/logos/peugeot-logo.jpg')} alt="Peugeot Logo" />
                <span>Peugeot</span>
              </Link>
              <Link to="/van-search?make=Toyota" className="brand-logo">
                <img src={require('../assets/logos/toyota-logo.jpg')} alt="toyota Logo" />
                <span>toyota</span>
              </Link>
              <Link to="/van-search?make=Vauxhall" className="brand-logo">
                <img src={require('../assets/logos/vauxhall-logo.jpg')} alt="Vauxhall Logo" />
                <span>Vauxhall</span>
              </Link>
              
              {/* Add more brands as needed */}
            </>
          )}
        </div>
        <button onClick={toggleShowBrands} className="view-all-brands-btn">
          {showAllBrands ? 'Hide all brands' : 'Show all brands'}
        </button>
      </section>

      {/* Expert Picks Section */}
      <section className="expert-picks">
        <h2>Top picks from the experts</h2>
        <div className="picks-grid">
          <div className="pick-card">Best small vans</div>
          <div className="pick-card">Best electric vans</div>
          <div className="pick-card">Best value for money</div>
          <div className="pick-card">Best high-capacity vans</div>
        </div>
        <Link to="/expert-reviews" className="view-more-reviews">See more reviews</Link>
      </section>

      {/* FAQ Section */}
      <section className="faq">
        <h2>Your questions answered</h2>
        {faq.map((item, index) => (
          <div
            key={index}
            className="faq-item"
            onClick={() => toggleFaq(index)}
          >
            <div className="faq-question">
              <span className="question-text">{item.question}</span>
              <span className={`faq-arrow ${item.isOpen ? 'open' : ''}`}></span>
            </div>
            {item.isOpen && <div className="faq-answer">{item.answer}</div>}
          </div>
        ))}
      </section>

      {/* Newsletter Section */}
      <section className="newsletter">
        <h2>Get the latest Vanir Motor Group offers and van reviews.</h2>
        <form className="newsletter-form">
          <input type="email" placeholder="Enter your email" />
          <button className="cta-button">Sign up</button>
        </form>
      </section>
    </div>
  );
}

export default UsedVans;
